module.exports = __webpack_public_path__ + "static/media/logos-1.766916c6.svg";